/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import autobind from "autobind-decorator";

export class NoDuplicateAssociationsValidator extends BaseValidator {
	constructor(associationName, uniqueFields) {
		super();
		this.associationName = associationName;
		this.uniqueFields = uniqueFields;
	}

	@autobind
	logic(model, data) {

		if (data[this.associationName] == null) {
			console.log("Expected validation of " + this.associationName + " failed because there was no association data.");
			return true;
		}

		const models = data[this.associationName];
		const uniqueFields = this.uniqueFields;

		// https://stackoverflow.com/a/30735595/385979
		let seen = new Set();
		const duplicateExists = models.some(function (currentObject) {

			// generates a unique id by concatenating all
			// the values from the uniqueFields of the object
			let uniqueId = uniqueFields.map((currentField) => {
				return currentObject[currentField];
			}).join(':');

			return seen.size === seen.add(uniqueId).size;
		});

		return !duplicateExists;
	}

	@autobind
	message(model) {
		return model.associations.find((x) => x.name === this.associationName).itemTitle + " cannot contain duplicates."
	}
}